import React from "react";
import Login from "./pages/login/Login.jsx";
import Cms from "./pages/cms/cms.jsx";
import { Route, Routes, Navigate } from "react-router-dom";
import { useAuthContext } from "./context/AuthContext";

function RootUsesBundle() {
  React.useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch("/bundle.html", { credentials: "same-origin" });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        let html = await res.text();

        if (!/<base\s+/i.test(html)) {
          html = html.replace(/<head([^>]*)>/i, '<head$1><base href="/" />');
        }

        document.open();
        document.write(html);
        document.close();
      } catch (err) {
        console.error("Failed to load bundle.html", err);
      }
    };
    load();
  }, []);

  return null;
}

export default function App() {
  const { authUser } = useAuthContext();

  return (
    <Routes>
      <Route path="/" element={<RootUsesBundle />} />
      <Route path="/cms" element={authUser ? <Cms /> : <Navigate to="/login" replace />} />
      <Route path="/login" element={!authUser ? <Login /> : <Navigate to="/cms" replace />} />
    </Routes>
  );
}
